import React from 'react';
import PropTypes from 'prop-types';
import VerticalTextLockup from '../../Global/Typography/VerticalTextLockup';

const MinimalContentTeaser = ({ href, title, summary, image }) => (
  <a href={href} className="minimal-content-teaser dark-link">
    {image &&
      <img alt="" src={image} />
    }
    <div className="minimal-content-text">
      <VerticalTextLockup
        title={<p className="like-p">{title}</p>}
        subtitle={<p className="like-small">{summary}</p>}
      />
    </div>
  </a>
);

MinimalContentTeaser.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  image: PropTypes.string,
};

export default MinimalContentTeaser;



// WEBPACK FOOTER //
// ./library/app/components/Global/Teasers/MinimalContentTeaser.js